import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { TranslatorService } from '@app/services/translator/translator.service';

@Injectable({
  providedIn: 'root',
})
export class TitleResolver implements Resolve<string> {
  private readonly translatorService = inject(TranslatorService);
  private readonly titleService = inject(Title);

  resolve(route: ActivatedRouteSnapshot): string {
    const title = route.data['title'];
    const translatedTitle = this.translatorService.translate(title);
    this.titleService.setTitle(translatedTitle);
    return translatedTitle;
  }
}
